import { Box } from '@mui/material';
import CustomToolbar from '../../files/custom_toolbar';
import { red } from '../../../theme/themePrimitives';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { quillFormats, quillModule } from '../../../helper/react-quill';
import ReactQuill, { ReactQuillProps } from 'react-quill';

import 'react-quill/dist/quill.snow.css';

interface QuillEditorRef {
  insertTextAtCursor: (text: string) => void;
}

interface QuillInputProps extends Partial<ReactQuillProps> {
    label?: string;
    value?: string;
    onChange?: (newValue: string) => void;
    placeholder?: string;
    disabled?: boolean;
    error?: boolean;
    quillHeight?: string;
}

const QuilInputComponent = forwardRef<QuillEditorRef, QuillInputProps>(({
    value = '',
    onChange = () => null,
    placeholder = '',
    disabled = false,
    error,
    quillHeight,
    ...props
}, ref) => {
    const quillRef = useRef<ReactQuill | null>(null);
    // Expose Quill's getEditor method to parent via ref
    useImperativeHandle(ref, () => ({
        insertTextAtCursor: (text: string) => {
            const editor = quillRef.current?.getEditor();
            const range = editor?.getSelection();
            if (range && editor) {
                editor.insertText(range.index, text);
                editor.setSelection({ index: range.index + text.length, length: 0 });
            }
        }
    }));

    return <Box>
        <CustomToolbar />
        <ReactQuill
            ref={quillRef}
            onChange={(content) => onChange(content)}
            value={value}
            placeholder={placeholder}
            modules={quillModule}
            formats={quillFormats}
            theme="snow"
            readOnly={disabled}
            style={{
                height: quillHeight,
                borderBottomLeftRadius: '10px',
                borderBottomRightRadius: '10px',
                border: error ? `1px solid ${red[300]}` : 'none'
            }}
            {...props}
        />
    </Box>;
});

QuilInputComponent.displayName = 'QuilInputComponent';

export default QuilInputComponent;